import React from 'react';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import { useTranslation } from 'react-i18next';
import SubscribeForm from '../components/subscribeForm';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

const Subscribe = () => {

   const { t } = useTranslation();

   const url = 'https://ourmind.us20.list-manage.com/subscribe/post?u=6af77d47f5cb204aed3de5cf5&amp;id=47be4d5abe';
	
  	return (
  		<section>
         <div className="container">
            <div className="row">
               <div className="col-md-8 offset-md-2">
                  <div className="footer-text">
                     <MailOutlineIcon className="mat-ui-icon large" />
                     {/* <img src="assets/images/email.png" alt="email" /> */}
                     <h2 className="title pink-title text-center md-margin-top">{t('subscribe to')} <span>ourmind</span> - {t('newsletter')}</h2>
                     <p> {t("stay connected with us")} </p>
                     <MailchimpSubscribe
                        url={url}
                        render={({ subscribe, status, message }) => (
                           <div>
                           <SubscribeForm onSubmitted={formData => subscribe(formData)} />
                           {status === "sending" && <div className="subscribe subscribe-sending" >{t('sending')}...</div>}
                           {status === "error" && <div className="subscribe subscribe-error" dangerouslySetInnerHTML={{__html: message}}/>}
                           {status === "success" && <div className="subscribe subscribe-success" >{t('subscribed')}!</div>}
                           </div>
                        )}
                     />
                  </div>
               </div>
            </div>
         </div>
      </section>
  	);
  }

export default Subscribe;


// WEBPACK FOOTER //
// ./src/components/subscribe.js